(() => {
  if (document.documentElement.lang.split('-')[0] !== 'ar') return;
  const initialize = () => {
    document.querySelectorAll('.firmware-guide .faq-item').forEach((item, index) => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      if (!question || !answer || question.dataset.arFaqReady) return;
      question.dataset.arFaqReady = 'true';
      answer.id ||= `ar-firmware-faq-answer-${index + 1}`;
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-controls', answer.id);
      question.setAttribute('aria-expanded', 'false');
      const toggle = () => {
        const open = question.getAttribute('aria-expanded') !== 'true';
        question.setAttribute('aria-expanded', String(open));
        answer.style.display = open ? 'block' : 'none';
        const icon = question.querySelector('.faq-icon');
        if (icon) icon.textContent = open ? '−' : '+';
      };
      question.addEventListener('click', toggle);
      question.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
